import { createStore } from 'vuex';
import authModule from './auth';
import appModule from './app';
import loadingModule from './loading';
import listagensModule from './listagens';
import mensagensModulo from './mensagens';
import landingPageModule from './landingPage';
import autosaveLandingPagePlugin from './plugins/autosaveLandingPage';

const store = createStore({
    modules: {
        auth: authModule,
        loading: loadingModule,
        listagem: listagensModule,
        app: appModule,
        mensagens: mensagensModulo,
        landingPage: landingPageModule,
    },
    plugins: [autosaveLandingPagePlugin],
});

export default store;
